<template>
    <div>
          <div v-for="item in Object.keys(items)" :key="item">
            <div class="columns is-gapless is-paddingless is-mobile" style="margin: 0;">
              <div class="column is-11" style="margin: 0;">
                <b-checkbox
                    :size="size" type="is-teal"
                    :native-value="item"
                    :id="item"
                    v-model="selectedItems"
                    :disabled="!(filteredItems[item] || value.includes(item))">
                    {{item}}
                </b-checkbox>
              </div>
              <div :class="['column', 'is-1', size == 'is-small' ? 'is-size-7' : 'is-size-5']" style="margin: 0; text-align: right; color: gray; text-align: right;">
                <div v-if="filteredItems[item]">
                  {{filteredItems[item]}}
                </div>
                <div v-else>
                  0
                </div>
              </div>
            </div>
          </div>
    </div>
</template>

<script>
    export default {
      name: 'SelectionWithQuantityDisplay',
      data() {
          return {
            selectedItems: this.value,
          }
      },
      props: {
        items: Object,
        filteredItems: Object,
        value: Array,
        size: {
          type: String,
          default: 'is-small'
        },
        type:String
      },
      methods: {
        handleInput () {
          this.$emit('input', this.selecteditems);
        }
      },
      watch:{
        selectedItems: function(){
          this.$emit('input', this.selectedItems);
        }
      }
    }
</script>

<style lang="scss" scoped>
</style>
